/**
 * Additional Trials worklist cell — `additional_studies` tags open the linker modal.
 */

import TagWithOverflow from "../../../components/tagWithOverflow/tagWithOverflow";

/** Props for the additional-trials table cell. */
export interface AdditionalTrialsCellProps {
  /** Display labels from the row's `additional_studies` list. */
  tags: string[];
  /** Opens the add-monitoring-trial flow for this row. */
  onAddClick: () => void;
}

/**
 * Render linked trial tags (or an em dash) as the control that opens the linker modal.
 *
 * @param props - {@link AdditionalTrialsCellProps}
 * @returns Additional trials cell content
 */
export function AdditionalTrialsCell({ tags, onAddClick }: AdditionalTrialsCellProps) {
  const hasTags = tags.length > 0;

  return (
    <button
      type="button"
      className="flex w-full flex-wrap items-center justify-center gap-1 border-0 bg-transparent p-0 text-inherit hover:cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-tertiaryBlue-4"
      onClickCapture={(event) => {
        event.stopPropagation();
        onAddClick();
      }}
      aria-label={
        hasTags
          ? "Manage linked clinical trials"
          : "Add clinical trial"
      }
    >
      {hasTags ? (
        <TagWithOverflow
          className="table-cell-tag-with-overflow"
          tags={tags}
          maxVisibleTags={1}
        />
      ) : (
        <span className="text-primaryGray-4">—</span>
      )}
    </button>
  );
}

export default AdditionalTrialsCell;
